import { ActionResult, DirectoryItem, DirectoryItemUpdate } from '../types'
import { ExecutableAction } from './action'

export class EditAction extends ExecutableAction<DirectoryItem> {
  static readonly actionName = 'edit'
  public readonly actionName = EditAction.actionName

  private readonly reversedEdits: DirectoryItemUpdate

  constructor(readonly item: DirectoryItem, readonly edits: DirectoryItemUpdate) {
    super()
    this.reversedEdits = Object.fromEntries(
      Object.entries(edits).map(([key]) => [key, item[key as keyof DirectoryItemUpdate]])
    ) as DirectoryItemUpdate
  }

  override async execute(tree): Promise<ActionResult<DirectoryItem>> {
    try {
      const updatedNode = tree.updateNodeDetails(this.item.id, this.edits)
      if (updatedNode) {
        return {
          status: 'success',
          data: updatedNode
        }
      }
      return {
        status: 'error',
        message: `Failed to rename item with ID ${this.item.id}`
      }
    } catch (e) {
      return {
        status: 'error',
        message: `Failed to rename item with ID ${this.item.id}`,
        error: e instanceof Error ? e : undefined
      }
    }
  }

  override async undo(tree): Promise<ActionResult<DirectoryItem>> {
    return new EditAction(this.item, this.reversedEdits).execute(tree)
  }
}
